{
    "ai_modal_title_1": "Mejora tu texto con IA",
    "ai_modal_title_2": "Genera nuevo texto usando IA",
    "ai_description": "Utiliza herramientas de generación de contenido con IA para mejorar tus textos.",
    "ai_learn_more": "Más información",
    "ai_copy_text": "Copiar texto",
    "ai_describe_your_text": "Describe el tema de tu texto",
    "ai_describe_your_text_example": "Ejemplo: Una breve descripción para una tienda en línea que vende jabón artesanal",
    "ai_new_request": "Crear nueva solicitud",
    "ai_create_text": "Generar texto",
    "ai_apply_text": "Aplicar texto",
    "ai_try_one_more": "Inténtalo de nuevo",
    "ai_correct_errors": "Corregir errores",
    "ai_make_longer": "Ampliar",
    "ai_make_shorter": "Reducir",
    "ai_simplify": "Simplificar",
    "ai_business_tone": "Formal",
    "ai_ceremonial_tone": "Festivo",
    "ai_fun_tone": "Alegre",
    "ai_friendly_tone": "Amistoso",
    "ai_change_tone": "Cambiar tono de voz",
    "ai_improve_text": "Mejorar texto",
    "ai_words_number": "Número de palabras:",
    "ai_translate": "Traducir",
    "ai_translate_to_ru": "Traducir al ruso",
    "ai_translate_to_en": "Traducir al inglés",
    "ai_add_creativity": "Añadir enfoque creativo",
    "ai_text_too_large": "Tu texto es demasiado largo para utilizar la IA. Crea una versión más corta o genera un nuevo texto sobre el tema deseado con ayuda de la IA.",
    "ai_translate_to_ua": "Traducir al ucraniano",
    "ai_translate_to_es": "Traducir al español",
    "ai_translate_to_pt": "Traducir al portugués",
    "ai_translate_to_tr": "Traducir al turco",
    "ai_translate_to_fr": "Traducir al francés",
    "ai_translate_to_de": "Traducir al alemán",
    "ai_translate_to_it": "Traducir al italiano",
    "ai_translate_to_pl": "Traducir al polaco",
    "ai_free_request_error": "Se han terminado las solicitudes gratuitas",
    "ai_free_request_number": "Número de solicitud: {{ FREE_KEY }} / {{ FREE_KEY_LIMIT }}",
    "ai_request_limit_info": "Puedes utilizar hasta 200 solicitudes de herramientas de IA gratis. Para hacer más solicitudes, activa tus claves API para el proveedor de IA en la configuración de tu cuenta.",
    "cancel": "Cancelar",
    "gpt_error_quota": "Has alcanzado tu límite de solicitud de API. Para continuar usando herramientas de IA, verifica tu límite actual o añade fondos a tu saldo de crédito en la configuración de la cuenta de OpenAI.",
    "ai_generated_disclaimer": "Tú eres responsable del texto generado. Revísalo antes de publicarlo."
}
